/**
 * Keyboard tools.
 */
H_Tools.key = (() => {
    /**
     * Determines if the supplied event is for the Escape key. Returns a representative boolean
     * value.
     *
     * @param {*} event An event, e.g. from a `keydown` event listener
     */
    function isEscape(event) {
        if ('key' in event) {
            return event.key === 'Escape' || event.key === 'Esc';
        }
        return event.keyCode === 27;
    }

    // Return an object to expose inner functions
    return {
        isEscape: isEscape,
    };
})();
